import { CustomerCreatePage } from '@/features/customer/pages/CustomerCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/customer/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["customer.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: CustomerCreatePage,
})
